module.exports = __webpack_public_path__ + "media/audiosprite.1a26f161.ogg";